import { SystemUserPermissions } from 'api/endpoints/users';

const TEXTS = {
  ACCESS: 'Access',
  FIELDS: {
    FIRST_NAME: 'First name',
    LAST_NAME: 'Last name',
    EMAIL: 'Email',
    PHONE_NUMBER: 'Phone number',
    SYSTEM_ROLE: 'Select role in the system',
    ROLE: 'Select tenant role',
    TENANT: 'Select tenant',
    PERMISSIONS: 'Select permissions',
  },
  ALL_PERMISSIONS_ARE_SELECTED: 'All permissions are selected',
  ADD_TENANT: 'Add Tenant',
  CANCEL: 'Cancel',
  SUBMIT: 'Save changes',
  NAME_ERROR: 'A name must not contain numbers or special characters.',
};

const PERMISSION: Record<keyof SystemUserPermissions, SelectItem> = {
  allowDeleteInstance: {
    label: 'Allow delete instance',
    value: 'allowDeleteInstance',
  },
  allowUpdateVariables: {
    label: 'Allow edit final data & variables',
    value: 'allowUpdateVariables',
  },
  allowReprocessInstance: {
    label: 'Allow reprocess instance',
    value: 'allowReprocessInstance',
  },
  allowStartStopPolling: {
    label: 'Allow start/stop polling',
    value: 'allowStartStopPolling',
  },
};

export { TEXTS, PERMISSION };
